export default "__VITE_ASSET__C60J9vqj__"